import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Divider,
  useTheme
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowBack } from "@mui/icons-material";
import backgroundImage from "../img/background.png";

const Sidebar = ({ selectedCompany, selectedPlan, selectedPrice }) => {
  const price = parseFloat(selectedPrice) || 0; // Ensure selectedPrice is a number
  const gst = price * 0.18;
  const finalPrice = price + gst;

  return (
    <Box
      sx={{
        padding: "2%",
        background: "#a05cf4",
        color: "white",
        borderRadius: "18px",
        width: { xs: "100%", md: "25%" },
        position: { xs: "static", md: "absolute" },
        marginTop: { xs: "27%", md: "0" },
        right: { md: "5%" },
        top: { md: "15%" },
        bottom: { md: "15%" },
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h4" sx={{ marginTop: 0 }}>
          Final Pricing
        </Typography>
        <Divider sx={{ marginBottom: "10px" }} />
        <Typography sx={{ fontSize: "10px", marginBottom: "10px" }}>
          {selectedCompany ? (
            <span style={{ color: "yellow", fontSize: "14px" }}>
              Selected Company:{" "}
              <span style={{ color: "white", fontSize: "14px" }}>
                {selectedCompany}
              </span>
            </span>
          ) : (
            "No company selected"
          )}
        </Typography>
        <Typography sx={{ color: "yellow", fontSize: "14px", mb: "10px" }}>
          {selectedPlan ? (
            <span style={{ color: "yellow", fontSize: "14px" }}>
              Selected Plan:{" "}
              <span style={{ color: "white", fontSize: "14px" }}>
                {selectedPlan}
              </span>
            </span>
          ) : (
            "No plan selected"
          )}
        </Typography>
        <Divider sx={{ backgroundColor: "#fff", marginBottom: "10px" }} />
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            Price
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "right",
              marginRight: "-40px",
            }}
          >
            :
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "right",
            }}
          >
            ₹{price.toFixed(2)}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            GST (18%)
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "right",
            }}
          >
            :
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              textAlign: "right",
            }}
          >
            ₹{gst.toFixed(2)}
          </Typography>
        </Grid>
        <Divider sx={{ backgroundColor: "#ffffff", marginY: 1 }} />
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            variant="h4"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "left",
              marginRight: "5px", // Adjust spacing as needed
            }}
          >
            Final Price
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            :
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "right",
              marginLeft: "5px", // Adjust spacing as needed
            }}
          >
            ₹{finalPrice.toFixed(2)}
          </Typography>
        </Grid>
      </Box>

      <Box sx={{ textAlign: "left", marginTop: "-1.5%" }}>
        <Typography variant="body2" sx={{ color: "#ede" }}>
          <Divider sx={{ backgroundColor: "#ffffff", marginY: 1 }} />
          <span className="small" style={{ color: "#FA0606" }}>
            * TermsofService :-{" "}
          </span>
          This is a one-time payment for a particular company. For further
          assistance, please visit <a href="www.Nexensus.com">Nexensus</a>.
        </Typography>
      </Box>
    </Box>
  );
};

const CheckoutPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [formData, setFormData] = useState({
    Name: "",
    selectedCompany: "",
    email: "",
    phone: "",
  });

  const [showContactInfo, setShowContactInfo] = useState(true);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  const location = useLocation();
  const { selectedPlan, selectedCompany, selectedPrice } = location.state || {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const price = parseFloat(selectedPrice);
    let buttonId = "";
    if (price === 450) {
      buttonId = "pl_OWtO9XgHfOTDcC";
    } else if (price === 5100) {
      buttonId = "pl_OWqYJupIg46TKl";
    } else if (price === 11000) {
      buttonId = "pl_OWqYH2XEKBiWRm";
    }

    if (buttonId) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/payment-button.js";
      script.dataset.payment_button_id = buttonId;

      const form = e.target;
      form.appendChild(script); // Append script to the form

      console.log(formData);
    }
  };

  const getCurrentMonthYear = () => {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const year = now.getFullYear();
    return `${year}-${month}`;
  };

  const toggleContactInfo = () => {
    setShowContactInfo(!showContactInfo);
    if (!showContactInfo) {
      setShowPaymentOptions(false); // Close payment options if contact info is opened
    }
  };

  const togglePaymentOptions = () => {
    setShowPaymentOptions(!showPaymentOptions);
    if (!showPaymentOptions) {
      setShowContactInfo(false); // Close contact info if payment options are opened
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: { xs: 2, md: 0 },
        flexDirection: { xs: "column-reverse", md: "row" },
        padding: "5%",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "5%",
          left: "5%",
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          variant="contained"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          background: (theme)=>
            theme.palette.mode === 'light'? 'white' : '#212121',
          borderRadius: "8px",
          padding: "3%",
          marginLeft: { xs: "0", md: "-20%" },
          width: { xs: "100%", md: "70%" },
          maxWidth: "800px",
          boxShadow: "15px 15px 20px 0px #36454f",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h3" align="left" gutterBottom>
          Checkout
        </Typography>
        <Box sx={{ borderBottom: "1px solid #ccc", my: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={toggleContactInfo}
            >
              <Typography variant="h6">Contact Information</Typography>
              <ExpandMoreIcon />
            </Box>
            {showContactInfo && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Company Name"
                    variant="outlined"
                    fullWidth
                    name="Company Name"
                    value={selectedCompany || formData.Name}
                    onChange={handleChange}
                    required
                    InputProps={{
                      style: { fontSize: "11px" }, // Change the font size here
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Phone"
                    variant="outlined"
                    fullWidth
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Box sx={{ borderBottom: "1px solid #ccc", my: 2 }} />
        <Box>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{
              background: "linear-gradient(90deg, #A020F0, #8A2BE2)",
              width: { xs: "100%", sm: "70%" },
            }}
          >
            Make Payment
          </Button>
        </Box>
      </Box>
      <Sidebar
        selectedCompany={selectedCompany}
        selectedPlan={selectedPlan}
        selectedPrice={selectedPrice}
      />
    </Box>
  );
};

export default CheckoutPage;
